import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { useParams } from "react-router-dom";
import ScreeningForm from '../ScreeningForm/ScreeningForm';
import { useTranslation } from 'react-i18next';
import { ButtonGroup, Button } from 'reactstrap';
import {
    loadScreening,
    updateScreening,
    loadScreeningLogs,
    loadPlaces,
    loadTickets
} from '../../../redux';
import { PageTitle } from '../../../components';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const ScreeningEdit = () => {
    const dispatch                 = useDispatch();
    const { t }                    = useTranslation();
    const { screening, isLoading } = useSelector(state => state.screenings);
    const { places }               = useSelector(state => state.places);
    const { logs }                 = useSelector(state => state.logs);
    const { setting }              = useSelector(state => state.settings);
    const { tickets }              = useSelector(state => state.tickets);
    const { screeningId }          = useParams();

    useEffect(() => {
        if (screeningId) {
            dispatch(loadScreening(screeningId));
            dispatch(loadScreeningLogs(screeningId));
            dispatch(loadTickets({
                "having_booked_screening_id": screeningId,
                fields: [
                    '_id', 'contact.firstname', 'contact.lastname',
                    'contact.email', 'status', 'type',
                    'activated_pricing.name', 'vdr_auth_serial',
                    'vdr_auth_key', 'bookings'
                ]
            }));
            dispatch(loadPlaces({ fields: [
                '_id', 'cinema', 'name',
                'number', 'opaque', 'city',
                'refs', 'capacity', 'map'
            ]}));
        }
    }, [screeningId]);

    const submit = values => {
        const payload = {}
        Object.keys(values).map(k => {
            switch (k) {
                case '_id':
                case 'description':
                case 'start_at':
                case 'stop_at':
                case 'title':
                case 'opaque':
                case 'note':
                    payload[k] = values[k];
                    break;
            }
        })
        dispatch(updateScreening(payload));
    };

    const actions =
        <ButtonGroup>
            <Button tag={Link} color="warning" to='/screenings' >
                <i className="fa fa-arrow-left"></i>&nbsp;
                { t('common.back') }
            </Button>
            {screening && setting.eshop?.uri && (
                <a target="_blank" className="btn btn-info" href={`${setting.eshop.uri}/screening/buy/${screening._id}`}>
                    <i className="fa fa-external-link-square"></i>&nbsp;
                    { t('screenings.see_on_eshop') }
                </a>
            )}
        </ButtonGroup>;

    const title = screening?.start_at ?
        <span>{t("common.screening", {count: 1})} - {screening?.title?.original || ''}</span> : null;

    const subtitle = screening?.start_at ?
        <small>{screening.start_at?.format('LLL')} - {screening.cinema_hall?.name} ({screening.cinema_hall?.cinema})</small> : null;

    return (
        <div className="ScreeningEdit">
            <PageTitle icon="television" title={title} subtitle={subtitle} actions={actions} />
            {(screening && Object.keys(screening).length > 0 && logs && tickets) ?
                <ScreeningForm
                    onSubmit={(values) => submit(values)}
                    logs={logs}
                    isLoading={isLoading}
                    setting={setting}
                    places={places}
                    tickets={tickets}
                />
                :
                <span className="loadingMessage"><i className="fa fa-spinner fa-spin"></i>&nbsp;Chargement en cours...</span>
            }
        </div>
    );
}

export default ScreeningEdit;
